import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'app-dialog-container',
    templateUrl: './dialog-container.component.html',
    styleUrls: ['./dialog-container.component.scss'],
    standalone: false,
})
export class DialogContainerComponent {
    @Input() loading = true;
    @Input() error = false;
    @Input() title!: string;

    @Output() closeEvent = new EventEmitter();

    closeForm() {
        this.closeEvent.emit();
    }
}
